import React from 'react';
import { motion } from 'framer-motion';
import { Plus, Search, Filter, Calendar, Users, DollarSign, MoreHorizontal } from 'lucide-react';
const needs = [{
  name: 'Summer Weekend Headliner',
  date: 'Jul 10, 2026',
  room: 'Main Stage',
  genre: 'Indie Rock / Alt',
  budget: '$3,000 - $5,000',
  status: 'Sourcing',
  matches: 42,
  owner: 'Dan'
}, {
  name: 'Folk/Americana Support',
  date: 'Jun 12, 2026',
  room: 'Main Stage',
  genre: 'Folk / Americana',
  budget: '$500 - $800',
  status: 'Offering',
  matches: 12,
  owner: 'Dan'
}, {
  name: 'Local Showcase Night',
  date: 'Jun 18, 2026',
  room: 'Tavern Room',
  genre: 'Any',
  budget: 'Door Split',
  status: 'Planning',
  matches: 85,
  owner: 'Mike'
}, {
  name: 'Late Night DJ Set',
  date: 'Jul 4, 2026',
  room: 'Tavern Room',
  genre: 'Electronic / House',
  budget: '$800 - $1,200',
  status: 'Confirmed',
  matches: 0,
  owner: 'Dan'
}];
export function EventNeedsPage() {
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} animate={{
    opacity: 1,
    y: 0
  }} className="max-w-7xl mx-auto" data-id="element-3475">
      {/* Header & Filters */}
      <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4 mb-6" data-id="element-3476">
        <div className="flex flex-wrap items-center gap-3" data-id="element-3477">
          <div className="relative" data-id="element-3478">
            <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-textMuted" data-id="element-3479" />
            <input type="text" placeholder="Search event needs..." className="pl-9 pr-4 py-2 bg-surface border border-border rounded-lg text-sm focus:outline-none focus:border-primary w-64" data-id="element-3480" />
          </div>
          <select className="px-3 py-2 bg-surface border border-border rounded-lg text-sm focus:outline-none focus:border-primary text-textMuted" data-id="element-3481">
            <option data-id="element-3482">All Statuses</option>
            <option data-id="element-3483">Sourcing</option>
            <option data-id="element-3484">Offering</option>
            <option data-id="element-3485">Confirmed</option>
          </select>
          <select className="px-3 py-2 bg-surface border border-border rounded-lg text-sm focus:outline-none focus:border-primary text-textMuted" data-id="element-3486">
            <option data-id="element-3487">All Rooms</option>
            <option data-id="element-3488">Main Stage</option>
            <option data-id="element-3489">Tavern Room</option>
          </select>
          <button className="p-2 bg-surface border border-border rounded-lg text-textMuted hover:text-textMain transition-colors" data-id="element-3490">
            <Filter className="w-4 h-4" data-id="element-3491" />
          </button>
        </div>
        <button className="px-4 py-2 bg-primary text-background rounded-lg hover:bg-primaryHover transition-colors font-medium flex items-center gap-2 text-sm shadow-[0_0_10px_rgba(245,158,11,0.2)]" data-id="element-3492">
          <Plus className="w-4 h-4" data-id="element-3493" />
          New Event Need
        </button>
      </div>

      {/* Table */}
      <div className="bg-surface border border-border rounded-xl overflow-hidden" data-id="element-3494">
        <div className="overflow-x-auto" data-id="element-3495">
          <table className="w-full text-sm text-left" data-id="element-3496">
            <thead className="bg-surface border-b border-border text-textMuted" data-id="element-3497">
              <tr data-id="element-3498">
                <th className="px-6 py-4 font-medium" data-id="element-3499">Need Name</th>
                <th className="px-6 py-4 font-medium" data-id="element-3500">Date(s)</th>
                <th className="px-6 py-4 font-medium" data-id="element-3501">Room</th>
                <th className="px-6 py-4 font-medium" data-id="element-3502">Genre Target</th>
                <th className="px-6 py-4 font-medium" data-id="element-3503">Budget</th>
                <th className="px-6 py-4 font-medium" data-id="element-3504">Status</th>
                <th className="px-6 py-4 font-medium text-right" data-id="element-3505">Matches</th>
                <th className="px-6 py-4" data-id="element-3506"></th>
              </tr>
            </thead>
            <tbody className="divide-y divide-border bg-background" data-id="element-3507">
              {needs.map((need, i) => <tr key={i} className={`hover:bg-surface/50 transition-colors cursor-pointer group ${need.status === 'Confirmed' ? 'opacity-60' : ''}`} data-id="element-3508">
                  <td className="px-6 py-4 font-medium group-hover:text-primary transition-colors" data-id="element-3509">
                    {need.name}
                  </td>
                  <td className="px-6 py-4 text-textMuted flex items-center gap-1.5" data-id="element-3510">
                    <Calendar className="w-3.5 h-3.5" data-id="element-3511" /> {need.date}
                  </td>
                  <td className="px-6 py-4 text-textMuted" data-id="element-3512">{need.room}</td>
                  <td className="px-6 py-4 text-textMuted" data-id="element-3513">{need.genre}</td>
                  <td className="px-6 py-4 text-textMuted" data-id="element-3514">{need.budget}</td>
                  <td className="px-6 py-4" data-id="element-3515">
                    <span className={`px-2 py-1 text-xs rounded font-medium ${need.status === 'Confirmed' ? 'bg-green-500/10 text-green-500' : need.status === 'Offering' ? 'bg-primary/10 text-primary' : need.status === 'Sourcing' ? 'bg-blue-500/10 text-blue-500' : 'bg-surface border border-border text-textMuted'}`} data-id="element-3516">
                      {need.status}
                    </span>
                  </td>
                  <td className="px-6 py-4 text-right" data-id="element-3517">
                    {need.matches > 0 ? <span className="px-2 py-1 bg-surface border border-border rounded text-xs font-medium" data-id="element-3518">
                        {need.matches} found
                      </span> : <span className="text-textMuted" data-id="element-3519">-</span>}
                  </td>
                  <td className="px-6 py-4 text-right" data-id="element-3520">
                    <button className="p-1 text-textMuted hover:text-textMain transition-colors rounded hover:bg-surface" data-id="element-3521">
                      <MoreHorizontal className="w-4 h-4" data-id="element-3522" />
                    </button>
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
      </div>
    </motion.div>;
}